import React, { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import CardHeader from "@mui/material/CardHeader";
import Swal from "sweetalert2";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import AsyncSelect from "react-select/async";
// Images
import { useContext } from "react";
import masterCardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";
import { LanguageContext } from "App";
// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import DateTimePicker from "react-datetime-picker";

import CreateFacilityTypeReq from "Classes/Models/Requests/Administration/CreateFacilityTypeReq";
import CreateSessionReq1 from "Classes/Models/Requests/Administration/CreateSessionReq";
import SessionsApi from "Classes/API/Administration/SessionsApi";

const CreateSession = ({ setCreatedNewSession }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [Types, setTypes] = useState();
  const [TypesSearch, setTypesSearch] = useState();
  const [TypesLoaded, setTypesLoaded] = useState(false);
  const { translations } = useContext(LanguageContext);
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [Category, setCategory] = useState("");
  const [SecretName, setSecretName] = useState("");
  const [EgyptianPrice, setEgyptianPrice] = useState("");
  const [ArabPrice, setArabPrice] = useState("");
  const [OtherPrice, setOtherPrice] = useState("");
  const [IsHalfDuration, setIsHalfDuration] = useState(false);
  const [IsAssessmentSession, setIsAssessmentSession] = useState(false);

  const [Image, setImage] = useState("");

  const [ErrorText, SetErrorText] = useState(false);
  const [SuccessText, setSuccessText] = useState("");

  const GetFacilityTypes = async () => {
    let CreateFacilityTypeReq = new CreateFacilityTypeReq();

    CreateFacilityTypeReq.TypeName = TypesSearch;
    CreateFacilityTypeReq.Description = TypesSearch;
    CreateFacilityTypeReq.Category = TypesSearch;

    let res = await FacilitiesApi.SearchFacilityTypes(CreateFacilityTypeReq);

    if (res.status == "Success") {
      setTypes(res.data.list);
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: item.typeName });
      });
    }
  };

  const onSubmit = async () => {
    if (!Name) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterName,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }
    if (!Description) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterDescription,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }
    if (!Category) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterCategory,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    let CreateSessionReq = new CreateSessionReq1();
    CreateSessionReq.Name = Name;
    CreateSessionReq.Description = Description;
    CreateSessionReq.Category = Category;
    CreateSessionReq.SecretName = SecretName;
    CreateSessionReq.EgyptianPrice = EgyptianPrice;
    CreateSessionReq.ArabPrice = ArabPrice;
    CreateSessionReq.OtherPrice = OtherPrice;
    CreateSessionReq.IsHalfDuration = IsHalfDuration;
    CreateSessionReq.IsAssessmentSession = IsAssessmentSession;
    CreateSessionReq.Id = "";

    // CreateSessionReq.Image = document.getElementById("sessionImageInput");

    var res = await SessionsApi.CreateSession(CreateSessionReq);

    if (res.status == "Success") {
      Swal.fire({
        title: "success",
        text: "Created successfully",
        icon: "success",
      });
      setCreatedNewSession(true);
      document.getElementById("CreateSessionForm").reset();
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
  };

  return (
    <>
      <Card mb={3} className="mb-3">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.sessionPgSessionsSessions}
          </MDTypography>
          <MDButton
            onClick={() => onSubmit()}
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="success"
          >
            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
            &nbsp;{translations.sessionPgSessionsAddNewSession}
          </MDButton>
        </MDBox>

        <form id="CreateSessionForm" className="my-3">
          {/* Search form */}

          <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    onChange={(e) => setName(e.target.value)}
                    label={translations.FacilityPagesCreatenewFacilityTypename}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    onChange={(e) => setDescription(e.target.value)}
                    label={translations.FacilityPagesCreatenewFacilityTypedescription}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    onChange={(e) => setCategory(e.target.value)}
                    label={translations.FacilityPagesCreatenewFacilityTypecategory}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"text"}
                    onChange={(e) => setSecretName(e.target.value)}
                    label={translations.sessionPgSessionsSecretName}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"number"}
                    onChange={(e) => setEgyptianPrice(e.target.value)}
                    label={translations.sessionPgSessionsEgyptianPrice}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"number"}
                    onChange={(e) => setArabPrice(e.target.value)}
                    label={translations.sessionPgSessionsArabPrice}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"number"}
                    onChange={(e) => setOtherPrice(e.target.value)}
                    label={translations.sessionPgSessionsOtherPrice}
                    fullWidth
                  ></MDInput>
                </div>
                {/* <div className="col-md-4 mt-3">
                <div className="col-md-4 mt-3">
                  <MDInput
                    id="sessionImageInput"
                    type={"file"}
                    onChange={(e) => setImage(e.target.value)}
                    label={""}
                    fullWidth
                  ></MDInput>
                </div>
                  <label>
                    <input
                      type="checkbox"
                      className="mr-2"
                      defaultChecked={IsHalfDuration}
                      onChange={() => setIsHalfDuration(!IsHalfDuration)}
                    />
                    {translations.sessionPgSessionsIsHalfDuration}
                  </label>
                </div>
                <div className="col-md-4 mt-3">
                  <label>
                    <input
                      type="checkbox"
                      className="mr-2"
                      defaultChecked={IsAssessmentSession}
                      onChange={() => setIsAssessmentSession(!IsAssessmentSession)}
                    />
                    {translations.sessionPgSessionsIsAssessmentSession}
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default CreateSession;
